import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import routes from "./routes";
import store from "@/store";
//定义是否首次进入
let firstEntry = true;
//创建路由对象
const router = createRouter({
  history: createWebHashHistory("/hotel/"),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果通过浏览器的前进/后退按钮导航，恢复之前的滚动位置
    if (savedPosition) {
      return savedPosition;
    }
    // 如果有 hash，滚动到对应的元素
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    }
    // 否则滚动到顶部
    return { top: 0 };
  },
});
//导航守卫
router.beforeEach(async (to, from, next) => {
  let tokenState = true;
  //如果是首次进入验证一下token是否还生效
  if (firstEntry) {
    tokenState = await store.dispatch("aliveGet");
  }
  //必须满足token的存活时间，token是否还生效，token的是否存在
  if (store.getters.getToken && store.getters.checkToken && tokenState) {
    if (to.path != "/login") {
      next();
    } else {
      next({ path: "/home" });
    }
  } else {
    if (to.path == "/login") {
      next();
    } else {
      next({
        path: "/login",
        query: { loginAuto: !!store.getters.getLoginkey },
      });
    }
  }
});

export default router;
